import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardTitle,
  CardBody,
  Form,
  FormGroup,
  Input
} from 'reactstrap';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      formEmail: '',
      pending: false
    }
  }

  handleEmailInput = (e) => {
    this.setState({
      formEmail: e.target.value,
      errorMessage: ''
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      errorMessage: '',
      pending: true
    });

    this.props.onSendPasswordResetEmail(
      this.state.formEmail
    ).then(e => {
      this.props.onShowLoginPage({
        type: 'success',
        message: 'We\'ve sent a password reset link to your email'
      });
    }).catch(e => {
      this.setState({
        errorMessage: e.message || 'An error has occurred',
        pending: false
      });
    });
  }

  render() {
    return (
        <div className="ResetPasswordPage full-page d-flex justify-content-center align-items-center flex-column">

          {
            this.props.message && !this.state.errorMessage &&
            <Alert color={this.props.messageType || 'info'}>
              {this.props.message}
            </Alert>
          }

          {
            this.state.errorMessage &&
            <Alert color="danger">
              {this.state.errorMessage}
            </Alert>
          }

          <Card>
            <CardBody>
              <CardTitle className="text-center">Reset Password</CardTitle>
              <Form>
                <FormGroup>
                    <Input
                      type="email"
                      placeholder="Email"
                      invalid={this.state.errorMessage.toLowerCase().includes('email')}
                      value={this.state.formEmail}
                      onChange={this.handleEmailInput}
                    />
                  </FormGroup>
                <div className="d-flex mt-4 justify-content-center">
                  <Button
                    color="primary"
                    type="submit"
                    disabled={this.state.pending}
                    onClick={this.handleSubmit}
                  >
                    Reset Password
                  </Button>
                </div>
              </Form>

              <div className="mt-4 text-center">
                <div>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={this.props.onShowLoginPage}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      );
  }
}

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/pages/ResetPasswordPage.jsx